export default {
  employeeRoomList: [],
  employeeRoomListWithOwners: [],
  employeeRoomListWithTenants: [],
  employeeRoomListWithOtherClients: [],
  participants: [],
  unreadCount: 0,
  clientRoomId: null,
  selectedChat: {},
};
